import { render, staticRenderFns } from "./ChangeProgramme.vue?vue&type=template&id=21c48cf3"
import script from "./ChangeProgramme.vue?vue&type=script&lang=js"
export * from "./ChangeProgramme.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports